var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"RP-Home"},[_c('ul',{staticClass:"RP-MenuList"},_vm._l((_vm.MenuList),function(item,index){return _c('li',{key:index,staticClass:"MenuMaginLeft",class:[
      index % 6 == 0
        ? 'MenuYellow'
        : index % 6 == 1
          ? 'MenuBlue'
          : index % 6 == 2
            ? 'MenuRed'
            : index % 6 == 3
              ? 'MenuPurple'
              : index % 6 == 4
                ? 'MenuTurquoise'
                : 'MenuGreen',
    ],on:{"click":function($event){return _vm.goToMenu(item)}}},[_c('i',{class:item.Icon}),_c('div',{staticClass:"MenuName"},[_vm._v(" "+_vm._s(item.MenuName)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }